import { render, staticRenderFns } from "./amenity.vue?vue&type=template&id=2ee546b6&scoped=true"
import script from "./amenity.vue?vue&type=script&lang=js"
export * from "./amenity.vue?vue&type=script&lang=js"
import style0 from "./amenity.vue?vue&type=style&index=0&id=2ee546b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee546b6",
  null
  
)

export default component.exports